 import { PaginationType } from 'ds/components/pagination';
import { BuildingPermitItem } from '../types';
import { TableColumn } from 'ds/components/table';

export interface ColumnRendererProps<T> {
  item: T;
}

export enum BuildingPermitTableColumn {
    RequestDate = 'requestDate',
    Status = 'status',
    RequestedChange = 'requestedChange',
    LastEventDate = 'lastEventDate',
  }

export const genericColConfig = (width: string = '80px'): Partial<TableColumn<BuildingPermitItem>> => ({
  width,
  align: 'left',
  gap: 16,
});


export interface TableProps {
  isMobile: boolean;
  visibleRowsMobile: number;
  visibleRowsDesktop: number;
  paginationType?: PaginationType;
}

export interface BuildingPermitTableProps extends TableProps {
  data: BuildingPermitItem[];
  setActiveRecordIndex: (id: string[]) => void;
  activeRecordIndex: string[];
}

export const EMPTY_COL_CHAR = '-';

